/* eslint-disable import/prefer-default-export */
import axiosInstance from '../axios.instance';

export const getReviewsApi = (token, params) => axiosInstance.get('/user/reviews', {
  params,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const getUserReviewsApi = (userId, params) => axiosInstance.get(`/review/user/${userId}`, {
  params,
});

export const getProductReviewsApi = (link, params) => axiosInstance.get(`/review/product/${link}`, {
  params,
});
